export default __webpack_public_path__ + "static/media/information--safety-zone--g3.82f31562.png";